<div role="listbox" aria-label="Multi-select dropdown">
  <p>multi-select-dropdown works!</p>
</div>
